import './styles.scss'
import { Grid, Icon } from 'component-library'
import formatClasses from '@/utils/classes/formatClasses'
import { HTMLAttributes } from 'react'
import NumberFlow from '@number-flow/react'

export interface Props
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  range: number[]
  count: number
  handleCountChange: (count: number) => void
  suffix?: string
  showPlusSign?: boolean
}

export function NumberInput(props: Props) {
  const classes = {
    decrement: formatClasses(['decrement']),
    increment: formatClasses(['increment']),
    numberInput: formatClasses(['optiwatt-number-input']),
    value: formatClasses(['input-value', 'eased-value']),
  }

  return (
    <Grid
      className={classes.numberInput}
      data-value={props.count}
      gap="8px"
      placeContent="center"
    >
      <button
        className={classes.decrement}
        data-testing-id="decrement-button"
        onClick={() => props.handleCountChange(-1)}
        style={{
          visibility: props.count <= props.range[0] ? 'hidden' : undefined,
        }}
      >
        <Icon color="blue-500" name="ChevronDown" size={16} />
      </button>
      <div className={classes.value} data-testing-id="number-input-value">
        <span>
          {props.showPlusSign && props.count > 0 && '+'}
          <NumberFlow value={props.count} trend={0} />
          {props?.suffix ?? ''}
        </span>
      </div>
      <button
        className={classes.increment}
        data-testing-id="increment-button"
        onClick={() => props.handleCountChange(1)}
        style={{
          visibility: props.count >= props.range[1] ? 'hidden' : undefined,
        }}
      >
        <Icon color="blue-500" name="ChevronUp" size={16} />
      </button>
    </Grid>
  )
}

export default NumberInput
